const ljToken = (token?: string) => {
  if (token) {
    localStorage.setItem('ljToken', token);
  }
  return localStorage.getItem('ljToken');
};

const ljChatToken = (token?: string) => {
  if (token) {
    localStorage.setItem('ljChatToken', token);
  }
  return localStorage.getItem('ljChatToken');
};

const ljLoginEmail = (email?: string) => {
  if (email) {
    localStorage.setItem('ljLoginEmail', email);
  }
  return localStorage.getItem('ljLoginEmail');
};

const logout = () => {
  localStorage.removeItem('ljToken');
  localStorage.removeItem('ljChatToken');
};

const clearAllData = (withoutToken = false) => {
  localStorage.removeItem('ljLoginEmail');
  if (!withoutToken) {
    logout();
  }
};

export const AuthService = {
  ljToken,
  ljChatToken,
  ljLoginEmail,
  logout,
  clearAllData,
};
